// @flow

import React, { useState } from 'react';
import cx from 'classnames';
import { createUseStyles } from 'react-jss';
import { Theme } from '_lib/theme';

type Props = {
  initials: string;
  src?: string;
  alt?: string;
  size?: number;
};

const useStyles = createUseStyles((theme: Theme) => ({
  container: ({ size = 48 }: Props) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    overflow: 'hidden',
  }),
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  initials: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: 20,
    background: '#dadde6',
    color: '#86869e',
  },
  hidden: {
    visibility: 'hidden',
  },
}));

const Avatar = (props: Props) => {
  const classes = useStyles(props);

  const { alt, src, initials } = props;
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className={classes.container}>
      {/* Show initials in place off image */}
      {(!src || !isLoaded) && (
        <div className={classes.initials}>
          <span>{initials}</span>
        </div>
      )}
      {src && (
        <img
          alt={alt}
          src={src}
          className={cx(classes.img, { [classes.hidden]: !isLoaded })}
          onLoad={() => setIsLoaded(true)}
          style={{ visibility: !isLoaded ? 'hidden' : 'visible' }}
        />
      )}
    </div>
  );
};

export default Avatar;
